import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-charcoal-950 py-12 sm:py-16" aria-labelledby="guarantee-title" data-id="element-97" data-mp="4uqdmw6js2tb">
      <div className="mx-auto max-w-2xl px-5 text-center" data-id="element-98" data-mp="9ttiogmj291a">
        <ShieldCheckIcon className="mx-auto h-8 w-8 text-champagne" strokeWidth={1.25} aria-hidden="true" data-id="element-99" data-mp="9wfrejl5mul3" />
        <h2 id="guarantee-title" className="mt-4 font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-100" data-mp="jtbzwpb1zgpn">
          7-Day guarantee — no questions
        </h2>
        <p className="mx-auto mt-3 max-w-lg text-[14px] leading-relaxed text-body sm:text-[15px]" data-id="element-101" data-mp="sldyei1kamxa">
          Open the volumes. Use them in your life. If in 7 days it’s not what you
          expected, you get a{' '}
          <span className="text-ivory-100" data-id="element-102" data-mp="12gxi862upv5o">100% refund — no forms, no drama.</span>
        </p>
        <p className="mt-5 text-[10px] font-semibold uppercase tracking-[0.2em] text-muted" data-id="element-103" data-mp="17id605weyfrr">
          Return rate: less than 1%
        </p>
      </div>
    </section>;
}